import styled from "@emotion/styled";
import { IconButton } from "@mui/material";

export const CopyButton = styled(IconButton, {
  shouldForwardProp: prop => prop !== "addStyles",
})`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  padding-top: 1px;
  width: 18px;
  height: 18px;
  transition: color 0.3s ease;

  & path {
    stroke: #82818e;
  }

  &:hover {
    & path {
      stroke: #000;
    }
  }

  @media (min-width: ${p => p.theme.screenSizes.mdMax}) {
    width: 25px;
    height: 25px;
  }

  ${props => props.addStyles}
`;
